module.exports = "/img/_/_/_/assets/images/icon//energy.png?bf89344b0fcaaf3d57d94037449e7061";